import {getLocalStorage} from "@shared/utils/localStorageUtilities";
import {dateFormatter} from "@shared/utils/formatters";

export const showBuildInfo = () => {
  if (process.env.NODE_ENV === "production" || getLocalStorage("devMode", false)) {
    console.groupCollapsed("Build info");
    console.log("Version:   ", process.env.REACT_APP_GIT_VERSION);
    console.log("Hash:      ", process.env.REACT_APP_GIT_HASH);
    console.log("Branch:    ", process.env.REACT_APP_GIT_BRANCH);
    console.log(
      "Build date:",
      process.env.REACT_APP_BUILD_DATE &&
        dateFormatter.longDateTime(process.env.REACT_APP_BUILD_DATE as string, {
          displayInTimeZone: "user",
        })
    );
    console.groupEnd();
  }
};
